import React, { PropTypes } from 'react';

import TimeSpanSelect from './TimeSpanSelect/TimeSpanSelect';

const logoUrl = require('../assets/images/tls-logo.jpg');

const styles = {
  root: {
    padding: '15px 15px 5px',
  },
  logo: {
    maxHeight: 45,
    float: 'left',
    maxWidth: '100%',
  },
  timeSpanWrapper: {
    float: 'right',
    marginTop: -10,
  },
  labelStyle: {
    color: 'rgba(0, 0, 0, 0.6)',
    paddingLeft: 3,
    lineHeight: '40px',
    paddingTop: 12,
  },
  underlineStyle: {
    margin: '-1px 0',
  },
  iconStyle: {
    right: 0,
    top: 10,
  },
  clear: {
    clear: 'both',
  },
};

const Header = ({ timeSpan, onTimeSpanChange }) => (
  <header style={styles.root}>
    <img style={styles.logo} src={logoUrl} alt="Tornionlaakson Sähkö Oy" />
    <div style={styles.timeSpanWrapper}>
      <TimeSpanSelect
        timeSpan={timeSpan}
        onTimeSpanChange={onTimeSpanChange}
        labelStyle={styles.labelStyle}
        underlineStyle={styles.underlineStyle}
        iconStyle={styles.iconStyle}
      />
    </div>
    <div style={styles.clear} />
  </header>
);

Header.propTypes = {
  timeSpan: PropTypes.string.isRequired,
  onTimeSpanChange: PropTypes.func.isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js